/**
 * Which money a login may see, mirroring `routes/money_view.rs` on the server
 * (which enforces it: the values a login may not see arrive as 0).
 *
 * - Staff: revenue, cost and margin.
 * - A buyer (role `buyer` or a buyer allow-list): revenue, never cost or margin.
 * - A supplier (role `supplier` or a supplier allow-list): its own cost (what
 *   it earns), never revenue or margin.
 * - Both lists at once: none of it.
 *
 * Reports and the dashboard carry the server's own `money` flags; this is for
 * screens whose response does not, such as the leads list.
 */
export type MoneyVisibility = { revenue: boolean; cost: boolean; margin: boolean };

type MoneyUser = {
  role?: string | null;
  allowed_buyer_ids?: string[] | null;
  allowed_supplier_ids?: string[] | null;
} | null | undefined;

export function moneyViewFor(user: MoneyUser): MoneyVisibility {
  const buyer = user?.role === 'buyer' || user?.allowed_buyer_ids != null;
  const supplier = user?.role === 'supplier' || user?.allowed_supplier_ids != null;
  return {
    revenue: !supplier,
    cost: !buyer,
    margin: !buyer && !supplier,
  };
}
